import React, { memo, useState, useEffect, useMemo, useCallback } from "react"

import { useFunctions } from "../../hooks/useFunctions"

declare global {
  interface Window {
    subscribeTikTok: any
  }
}
export const withSubscribe = Component =>
  memo(({ name = "Subscribe", popup, newsletter, dismiss }: any) => {
    const { customerSubscribe, loading, errors } = useFunctions()
    const isBrowser = typeof window !== `undefined`
    const placeholder = newsletter?.additionalPlaceholder ? newsletter.additionalPlaceholder : null
    const successMessage = newsletter?.additionalSuccess ? newsletter.additionalSuccess : null

    const [data, setData] = useState({ email: "" })
    const [success, setSuccess] = useState(false)

    const handleSubmit = useCallback(
      async event => {
        event.preventDefault()
        const { customer } = await customerSubscribe(data?.email)
        if (customer?.id) {
          setSuccess(true)
          if (isBrowser) {
            window.subscribeTikTok(data?.email)
          }
          setData({ email: "" })
        }
      },
      [customerSubscribe, setData, data?.email]
    )

    const handleChange = ({ target: { type, name, value, checked } }) => {
      setData(prevState => ({
        ...prevState,
        [name]: type === "checkbox" ? checked : value,
      }))
    }

    useEffect(() => {
      if (success) {
        setTimeout(() => {
          dismiss()
        }, 5000)
      }
    }, [success, dismiss])

    Component.displayName = name
    return useMemo(
      () => (
        <Component
          data={data}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          loading={loading}
          errors={errors}
          popup={popup}
          success={success}
          placeholder={placeholder}
          successMessage={successMessage}
        />
      ),
      [data, loading, errors, popup, handleSubmit, success, placeholder, successMessage]
    )
  })
